import {
  faAngleLeft,
  faAngleRight,
  faAnglesLeft,
  faAnglesRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row } from "react-bootstrap";
import styled from "styled-components";

interface ApiTableFooterProps {
  currentPage: number;
  setCurrentPage: (page: number) => void;
  totalPages: number;
}

const PaginationBanner = styled.div`
  height: 50px;
`;

const PaginationButton = styled.button`
  height: 70%;
  border: none;
  background-color: inherit;
`;

const ApiTableFooter = ({
  currentPage,
  setCurrentPage,
  totalPages,
}: ApiTableFooterProps) => {
  const getTotalPages = () => {
    const r = totalPages > 0 ? totalPages : 1;
    return r;
  };

  return (
    <Row className="m-0 rounded">
      <PaginationBanner className="justify-content-center  d-flex bg-light">
        <div className="align-items-center d-flex justify-content-between">
          <PaginationButton
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(1)}>
            <FontAwesomeIcon icon={faAnglesLeft}></FontAwesomeIcon>
          </PaginationButton>
          <PaginationButton
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}>
            <FontAwesomeIcon icon={faAngleLeft}></FontAwesomeIcon>
          </PaginationButton>
          <div>
            Page {currentPage} of {getTotalPages()}
          </div>
          <PaginationButton
            disabled={currentPage === getTotalPages()}
            onClick={() => setCurrentPage(currentPage + 1)}>
            <FontAwesomeIcon icon={faAngleRight}></FontAwesomeIcon>
          </PaginationButton>
          <PaginationButton
            disabled={currentPage === getTotalPages()}
            onClick={() => setCurrentPage(totalPages)}>
            <FontAwesomeIcon icon={faAnglesRight}></FontAwesomeIcon>
          </PaginationButton>
        </div>
      </PaginationBanner>
    </Row>
  );
};

export default ApiTableFooter;
